export default "__VITE_ASSET__VytBQLAT__"